import { defaultDarkTheme, defaultTheme } from './buildAntdTheme';
import { packs, partnerDarkThemes, partnerThemes } from './partnerThemes';

import type { HirePortTheme } from './buildAntdTheme';
import type { ColorScheme } from './colorScheme';
import type { PackName } from './partnerThemes';

const packNameSet = new Set<string>(packs);

function isPackName(value: string): value is PackName {
  return packNameSet.has(value);
}

/** Picks the light or dark HirePort palette for a tenant theme name. */
export function resolveHirePortTheme(
  theme: HirePortTheme,
  colorScheme: ColorScheme,
): HirePortTheme {
  if (colorScheme === 'light') {
    if (isPackName(theme.themeName)) return partnerThemes[theme.themeName];
    return theme.themeName === 'default' ? defaultTheme : theme;
  }

  if (isPackName(theme.themeName)) return partnerDarkThemes[theme.themeName];
  return defaultDarkTheme;
}
